<template>
  <b-container class="h-100">
    <b-row class="h-100">
      <b-col
        class="d-flex flex-column justify-content-center login-wrapper--right-form"
      >
        <div class="d-flex">
          <b-img src="/img/logo.svg" fluid />
        </div>

        <div class="mt-4">
          <h1 class="font-weight-bold"></h1>
          <p class="mt-3">
            For security, we need to verify your {{ emailOrPhoneLabel }}.
          </p>
        </div>

        <transition name="slide-fade">
          <b-form @submit.prevent="onSubmitInfo" class="mt-4">
            <b-row no-gutters>
              <b-col cols="12">
                <b-form-group id="input-group-4" class="mb-0">
                  <label class
                    >Type in verification code sent to your
                    {{ emailOrPhoneLabel }}.
                  </label>
                  <b-form-input
                    id="input-4"
                    class="form-control effect-26"
                    type="text"
                    autofocus
                    required
                    placeholder="Enter verification code"
                    v-model="formInfo.token"
                  ></b-form-input>
                  <div class="input-error" v-if="formInfo.$getError('token')">
                    {{ formInfo.$getError('token')[0] }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="6" class="pr-2">
                <b-button
                  :to="{ name: 'user.profile-page' }"
                  class="btn-outlined bg-white text-dark"
                  block
                  >Skip</b-button
                >
              </b-col>

              <b-col cols="6" class="pl-2" block>
                <b-button class="pr-2" type="submit" variant="primary" block>
                  <b-spinner small v-if="formInfo.$busy" />
                  <span>Verify</span>
                  <b-img
                    class="float-right"
                    src="/img/arrow-right.svg"
                    alt="arrow-right"
                    width="20"
                  />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Form from '@/utils/form'
export default {
  data() {
    return {
      formInfo: new Form({
        via: '',
        token: ''
      }),
      loading: false
    }
  },
  computed: {
    emailOrPhoneLabel() {
      if (this.$route.params.account === 'email') {
        return 'email address'
      }
      return 'phone number'
    }
  },
  methods: {
    determineVia() {
      if (this.emailOrPhoneLabel === 'email address') {
        this.formInfo.via = 'email'
      } else {
        this.formInfo.via = 'phone_number'
      }
    },
    async onSubmitInfo() {
      this.formInfo.$busy = true
      await this.$api
        .post('auth/verification/verify', this.formInfo)
        .then(({ data }) => {
          this.formInfo.$busy = false
          this.$router.replace({
            name: 'auth.onboarding-page'
          })
        })
        .catch(error => {
          this.formInfo.$handleError(error)
        })
    }
  },
  mounted() {
    this.determineVia()
  }
}
</script>
